import React, { Component } from 'react';
import {toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {ValidateState} from '../../../functions';
import {API_URL, BASE_URL_FRONTEND} from '../../../constants';
import {updateValueInJson, showModalPageClass, hideModalPageClass, validateAccesoGeneral, getRoles, esUrl} from '../../../functions';
import axios from 'axios';
import $ from 'jquery';
import ModalMultimedia from '../../Partials/ModalMultimedia';

export default class AgregarPagina extends Component {

    constructor(props) {

        super(props);

        this.state = {
            tituloLongitud:0,
            descripcionLongitud:0,
            resource: {
                pagi_Titulo:"",
                pagi_Enlace:"",
                pagi_SeoTitulo:"",
                pagi_SeoImagen:"",
                pagi_Canonical:"",
                pagi_SeoDescripcion:"",
                pagi_SeguirEnlace:0,
                pagi_MostrarMotores:0,
                pagi_Script:"",
                pagi_PaginaSuperior:null,
                sect_Id:0,
                pweb_Id:0,
                plan_Id:24,
                pagi_Orden:this.props.location.state !== undefined ? this.props.location.state.totalRegistros + 1 : "",
                pagi_Activo:true,
                existUrl:false,
            },
            Validacion: {
                pagi_Titulo: {
                    Error: false,
                },
                pagi_Enlace: {
                    Error: false,
                }
            },
            modulos:{
                banner:[],
            },
            modulosWeb: [],
            paginasPadre: [],
            plantillas: [],
            sectores: [],
            perfiles: [],
            hasError:false,
            hasErrorProceso:false,
            added: false,
            security: cookie.load('user'),
            roles: [],
            fieldReturnMultimedia:"",
            agrupador:"",
            menuGeneral:[]
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.GenerateUrl = this.GenerateUrl.bind(this);
        this.getResponse = this.getResponse.bind(this);
      }

    getResponse = (urlSeleccionada) => {
        let resource = this.state.resource;
        let fieldReturn = this.state.fieldReturnMultimedia;

        if(fieldReturn!== ""){

            resource[fieldReturn] = urlSeleccionada;

            this.setState({resource:resource, fieldReturnMultimedia:""});
        }

        hideModalPageClass("divGestorArchivosMultimedia");
    }

    showModalMultimedia = (clase = "", campo = "") => {
        this.setState({fieldReturnMultimedia:campo});
        showModalPageClass(clase);
    }

    handleClickCancel(e) {

        e.preventDefault();

        const {history: {push}} = this.props;
        push('/paginas');
     }

     callFunctionButton = (event) => {

        event.preventDefault();

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.pagi_Titulo == '') {
            newState.Validacion.pagi_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.pagi_Enlace == '' || !esUrl(newState.resource.pagi_Enlace)) 
		{
            newState.Validacion.pagi_Enlace = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}PaginaUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'pagi_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url,
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {

            if (data.data.isSucess)
            {

                if(data.data.result.existUrl){

                    let newState = this.state;
                    newState.resource.existUrl = true;
                    newState.Validacion.pagi_Enlace = {Error: true};
                    this.setState(newState);

                }else{
                    let stateResponse = this.state;

                    stateResponse.added = true;
                    stateResponse.resource.existUrl = false;
                    stateResponse.resource.pagi_Titulo = '';
                    stateResponse.resource.pagi_Enlace = '';
                    stateResponse.resource.pagi_SeoTitulo = '';
                    stateResponse.resource.pagi_SeoImagen = '';
                    stateResponse.resource.pagi_SeoDescripcion = '';
                    stateResponse.resource.pagi_Canonical = '';
                    stateResponse.resource.pagi_Script = '';
                    stateResponse.resource.pagi_MostrarMotores = 0;
                    stateResponse.resource.pagi_SeguirEnlace = 0;
                    stateResponse.resource.sect_Id = 0;
                    stateResponse.resource.pweb_Id = 0;
                    stateResponse.resource.pagi_PaginaSuperior = 0;
                    stateResponse.resource.plan_Id = 24;
                    document.getElementById("sect_Id").selectedIndex = 0;
                    document.getElementById("pweb_Id").selectedIndex = 0;
                    document.getElementById("plan_Id").selectedIndex = 0;
                    document.getElementById("pagi_PaginaSuperior").selectedIndex = 0;
                    this.setState(stateResponse);

                    setTimeout(() => {
                        this.setState({added:false});
                    }, 3000);
                }

            } else
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => {
                    this.setState({hasErrorProceso:false});
                }, 3000);
            }
        }
        ).catch((error)=> {
            toast.error('Error no controlado.');
            this.setState({loading:false});
        });
    }

    checkedValidate = (item) => {
        let resource = this.state.resource;
        resource[item] = !resource[item];

        this.setState({resource:resource});
    }

	replaceAll(str, find, replace)
	{
		return str.replace(new RegExp(find, 'g'), replace);
	}

	generateSlugAutomatico(url)
	{
		let url2 = url.toLowerCase();
		let url3 = this.replaceAll(url2, " ","-");
		let url4 = this.replaceAll(url3, "á","a");
		let url5 = this.replaceAll(url4, "é","e");
		let url6 = this.replaceAll(url5, "í","i");
		let url7 = this.replaceAll(url6, "ó","o");
		let url8 = this.replaceAll(url7, "ú","u");
		let url9 = this.replaceAll(url8, "ñ","n");
		let url10 = this.replaceAll(url9, "@","");

		return BASE_URL_FRONTEND+"/"+url10;
	}

    GenerateUrl(event) {
		let ValorTitulo = $.trim($("#pagi_Titulo").val());

		let Url = this.generateSlugAutomatico(ValorTitulo);

		let copyResource = this.state.resource;
		copyResource["pagi_Enlace"] = Url;
		copyResource["pagi_Canonical"] = Url;
		copyResource["pagi_SeoTitulo"] = ValorTitulo;

		this.setState({
            resource: copyResource
        });
	}

    handleInputChange(event) {

        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;

        if(target.name == 'pagi_Enlace'){
            value = value.replace(/\s/g,'');

            copyResource['existUrl'] = false;

        }

        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;
        let descripcionLongitud = this.state.descripcionLongitud;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,
        }

        if(target.name == 'pagi_Titulo'){
            tituloLongitud = value.length;
        }
        if(target.name == 'pagi_SeoDescripcion'){
            descripcionLongitud = value.length;
        }
        this.setState({
            resource: copyResource,
            tituloLongitud: tituloLongitud,
            descripcionLongitud: descripcionLongitud,
            Validacion: validaciones
        });
    }

    componentDidMount()
    {

        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/paginas";

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        validateAccesoGeneral(locationState, pathNameList, rol);

        const url = `${API_URL}PaginaUX/Recursos`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            if(data.statusCode == 200){
                this.setState({
                    paginasPadre: data.result.paginasPadre,
                    plantillas: data.result.plantillas,
                    sectores: data.result.sectores,
                    perfiles: data.result.perfiles
                });
            }
        })
        .catch(error => {
            console.log('Error de comunicación');
        });

        this.loadModulosWeb();
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.callSearchModulos(e);
        }
    }

    callSearchModulos = (e) => {
        e.preventDefault();
        let texto = document.getElementById('titulo_modulo').value;
        this.loadModulosWeb(texto);
    }

    loadModulosWeb = (textoFilter = '') =>
    {
        let url = `${API_URL}GeneralUX/ObtenerLModulosWebNombre`;

        if(textoFilter != ''){
            url = `${API_URL}GeneralUX/ObtenerLModulosWebNombre/${textoFilter}`;
        }

        axios.get(url).then(response => response.data)
        .then((data) => {
            let resourceModulos = this.state.modulosWeb;
            resourceModulos = data.result;
            this.setState({modulosWeb:resourceModulos});
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

    render() {
        return (
            <div className="ContenedorDeNoticias">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de configuración general
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Agregar Página</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Agregar Página
                </div>

                {
                    this.state.hasErrorProceso ?
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar el registro.</div>
                        </div>
                    </div> : null
                }

                {
                    this.state.resource.existUrl ?
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, la url ingresada ya fue asignada a una página.</div>
                        </div>
                    </div> : null
                }

                {
                    this.state.added ?
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se realizó el registro correctamente.</div>
                        </div>
                    </div>: null
                }

                <div className="div_Modulos_Noticias">


                    <div className="div_WrapperEditarPagina">

                        <div className="txtFile x-1">
                            <input type="text" placeholder="Título" name='pagi_Titulo' id='pagi_Titulo' value={this.state.resource.pagi_Titulo} maxLength={200} className={this.state.Validacion.pagi_Titulo.Error ? "error" : ""}
                            onChange={this.handleInputChange} onBlur={this.GenerateUrl} />
                            <span data-length={200}>{this.state.tituloLongitud}/200</span>
                        </div>

                        <div className="txtFile x-1">
                            <input type="text" placeholder="Enlace" name='pagi_Enlace' value={this.state.resource.pagi_Enlace}
                            className={this.state.Validacion.pagi_Enlace.Error ? "error" : ""}
                            onChange={this.handleInputChange}/>
                        </div>

						<div className="txtFile x-1">
                            <select name='pagi_PaginaSuperior' id='pagi_PaginaSuperior' onChange={this.handleInputChange}>
                                <option value="0">Página Superior</option>
                                {
                                    this.state.paginasPadre.length > 0 ?
                                    this.state.paginasPadre.map((padre) => (
                                        <option value={padre.id}>{padre.nombre}</option>
                                    ))
                                    : null
                                }
                            </select>
                        </div>


                        <div className="txtFile x-1" style={{display:"none"}}>
                            <select name='plan_Id' id='plan_Id' onChange={this.handleInputChange}>
                                <option value="0">Plantilla</option>
                                {
                                    this.state.plantillas.length > 0 ?
                                    this.state.plantillas.map((plantilla) => (
                                        <option value={plantilla.id} selected={plantilla.id==24?'true':false}>{plantilla.nombre}</option>
                                    ))
                                    : null
                                }
                            </select>
                        </div>

                        <div className="txtFile x-1"  style={{display:"none"}}>
                            <select name='sect_Id' id='sect_Id' onChange={this.handleInputChange}>
                                <option value="0">Seleccionar Sector</option>
                                {
                                    this.state.sectores.length > 0 ?
                                    this.state.sectores.map((sector) => (
                                        <option value={sector.id}>{sector.nombre}</option>
                                    ))
                                    : null
                                }
                            </select>
                        </div>

                        <div className="txtFile x-1"  style={{display:"none"}}>
                            <select name='pweb_Id' id='pweb_Id' onChange={this.handleInputChange}>
                                <option value="0">Seleccionar Perfil</option>
                                {
                                    this.state.perfiles.length > 0 ?
                                    this.state.perfiles.map((perfil) => (
                                        <option value={perfil.id}>{perfil.nombre}</option>
                                    ))
                                    : null
                                }
                            </select>
                        </div>
                    </div>

                    <div className="clear"></div>

                    <div className="divModulo_Seo">
                        <h2>Configuración <strong>SEO</strong></h2>
                        <div className="divWrapperModulo_Seo">

                            <div className="txtFile x-2">
                                <input type="text" placeholder="SEO Title" name='pagi_SeoTitulo' value={this.state.resource.pagi_SeoTitulo}
                                onChange={this.handleInputChange}/>
                            </div>

                            <div className="txtFile x-1">
                                <textarea placeholder="SEO Descripción" name='pagi_SeoDescripcion' value={this.state.resource.pagi_SeoDescripcion} maxLength={200}
                                onChange={this.handleInputChange}  style={{height:"100px"}} />
                                <span data-length={200}>{this.state.descripcionLongitud}/200</span>
                            </div>

                            <div className="txtFile x-1 relative">
                            <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosMultimedia", "pagi_SeoImagen")}/>
                                <input type="text" placeholder="SEO Imagen" name='pagi_SeoImagen' value={this.state.resource.pagi_SeoImagen} maxLength={1000}
                                onChange={this.handleInputChange}/>
                            </div>

                            <div className="txtFile x-1">
                                <input type="text" placeholder="URL Canonical" name='pagi_Canonical' value={this.state.resource.pagi_Canonical}
                                onChange={this.handleInputChange}/>
                            </div>

                            <div className="divWrapperActive">
                            <div>
                                <span>Motores de busqueda <br />seguir enlaces</span>
                            </div>

                            <div>
                                <div className={this.state.resource.pagi_SeguirEnlace ? "containerActive backgroundPosition" : "containerActive"}
                                onClick={() => this.checkedValidate("pagi_SeguirEnlace")}>
                                    <div className={this.state.resource.pagi_SeguirEnlace ? "actionActive leftPosition" : "actionActive"}/>
                                </div>
                                <span>{this.state.resource.pagi_SeguirEnlace ? "Activado" : "Desactivado"}</span>
                            </div>

                            <div>
                                <span>Mostrar Pagina <br />Motores de Búsqueda </span>
                            </div>

                            <div>
                                <div className={this.state.resource.pagi_MostrarMotores ? "containerActive backgroundPosition" : "containerActive"}
                                onClick={() => this.checkedValidate("pagi_MostrarMotores")}>
                                    <div className={this.state.resource.pagi_MostrarMotores ? "actionActive leftPosition" : "actionActive"}/>
                                </div>
                                <span>{this.state.resource.pagi_MostrarMotores ? "Activado" : "Desactivado"}</span>
                            </div>

                        </div>

                        <div className="txtArea x-1">
                            <textarea placeholder="Pegue aquí su código JavaScript" value={this.state.resource.pagi_Script} name="pagi_Script"  onChange={this.handleInputChange} style={{height:"100px"}}/>
                        </div>
                    </div>
                    </div>


                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo"  onClick={(event) => this.callFunctionButton(event)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />
                <ModalMultimedia class="divGestorArchivosMultimedia" callback={this.getResponse.bind(this)}/>
            </div>
        )
    }
}